import { Component, input } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import {
  GoalStatusType,
  OverlayComponent,
  OverlayToggleDirective,
  TooltipButtonComponent
} from '@tdwb/core';

@Component({
  selector: 'td-wb-dashboard-goals-status-tooltip',
  templateUrl: './dashboard-goals-status-tooltip.component.html',
  styleUrls: ['./dashboard-goals-status-tooltip.component.scss'],
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    OverlayComponent,
    OverlayToggleDirective,
    TooltipButtonComponent
  ]
})
export class DashboardGoalsStatusTooltipComponent {
  readonly goalStatus = input<GoalStatusType | undefined>(undefined);
  readonly position = input<string>('center-right');
  readonly ariaDescribedBy = input<string | undefined>(undefined, { alias: 'aria-describedby' });
}
